import React from 'react';
import { Switch as MuiSwitch, SwitchProps, styled } from '@mui/material';

const Switch = styled((props: SwitchProps) => (
    <MuiSwitch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 64,
  height: 20,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 4,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(28px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: theme.colors.secondaryColor,
        opacity: 1,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: theme.colors.success,
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color: theme.colors.gray,
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 28,
    height: 12,
    borderRadius: 12,
    boxShadow: 'none',
    color: theme.colors.error,
    transition: theme.transitions.create(['color'], {
      duration: 300,
    }),
  },
  '& .Mui-checked .MuiSwitch-thumb': {
    color: theme.colors.success,
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: theme.colors.secondaryColor,
    opacity: 1,
    border: `px solid ${theme.colors.primaryColor}`,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      padding: 1,
      borderRadius: 15,
      background: 'linear-gradient(271.97deg, #4968EB 2.51%, #53D2FA 98.61%)',
      WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
      WebkitMaskComposite: 'xor',
      maskComposite: 'exclude',
      zIndex: -1,
    },
  },
}));

export default Switch;